export enum WebhookFormat {
    Json = 0,
    Teams = 1,
    Slack = 2
}